'use client';

import { useState } from 'react';
import { useRouter } from 'next/navigation';

export default function LoginPage() {
  const router = useRouter();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true); setErr('');
    const res = await fetch('/api/auth/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password }),
    });
    setLoading(false);
    if (res.ok) {
      router.push('/');
      router.refresh();
    } else {
      const d = await res.json().catch(() => ({}));
      setErr(d.error ?? '로그인 실패');
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-5">
      <form onSubmit={handleSubmit} className="bg-white rounded-xl p-8 shadow-md max-w-sm w-full">
        <h1 className="text-lg font-bold text-black mb-1">재고관리 시스템</h1>
        <p className="text-xs text-gray-400 mb-5">INFRAZA</p>
        <div className="space-y-3">
          <div>
            <label className="text-xs text-gray-500 mb-1 block">아이디</label>
            <input required value={username} onChange={e => setUsername(e.target.value)}
              className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-blue-400 text-gray-900" />
          </div>
          <div>
            <label className="text-xs text-gray-500 mb-1 block">비밀번호</label>
            <input required type="password" value={password} onChange={e => setPassword(e.target.value)}
              className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-blue-400 text-gray-900" />
          </div>
          {err && <p className="text-red-500 text-xs">{err}</p>}
          <button type="submit" disabled={loading}
            className="w-full bg-blue-600 text-white py-2.5 rounded-lg text-sm font-semibold hover:bg-blue-700 disabled:opacity-50">
            {loading ? '로그인 중...' : '로그인'}
          </button>
        </div>
      </form>
    </div>
  );
}
